import { useQuery } from "@tanstack/react-query";

import { api } from "@utils/api";

import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";

import { SickNote } from "@customTypes/sickNote";

import { sickNoteQKeys } from "./queryKey";


const select = (res: any) => {
  //   console.log(res.data);

  if (res.data.length) {
    const newData: SickNote[] = [];

    for (const i in res.data) {
      const {
        _id,
        start_date,
        end_date,
        files,
        doctor,
        consultation_id,
        created_at,
        patient_id,
      } = res.data[i];

      newData.push({
        id: _id,
        startDate: new Date(start_date),
        endDate: new Date(end_date),
        files,
        doctor: { id: doctor?._id, fullName: doctor?.full_name },
        createdAt: new Date(created_at),
        consultationId: consultation_id,
        patientId: patient_id,
      });
    }
    // console.log(newData);
    return newData;
  }
  return null;
};

interface QueryProps {
  patientId: string;
  consultationId: string;
}

export const useGetSickNotesForPatient = ({
  patientId,
  consultationId,
}: QueryProps) => {
  const handleErrors = useQueryErrorHandling();

  return useQuery({
    queryKey: sickNoteQKeys.patient(patientId),
    queryFn: () => {
      return api.get(`sick_notes/patient/${patientId}`, {
        params: {
          consultation_id: consultationId,
        },
      });
    },
    select,
    staleTime: Infinity,

    onError: (res: any) => {
      console.error("[From Get Sick Notes for Patient]", res);
      handleErrors(res, "query");
    },
  });
};
